<template lang="pug">
  div
    slot(
      :open-form="openForm"
    )

    portal(
      v-if="dialogId"
      :to="`${dialogId}.content`"
      v-slot="{ attrs, close }"
    )
      dv-manageable-combo-form(
        :value="attrs.item"
        :method="attrs.method"
        :schema="formSchema"
        @success="(data) => onSuccessForm({ data, close })"
      )
        template(v-slot:actions="{ loading, submit }")
          portal(:to="`${dialogId}.actions`")
            dv-btn(
              :loading="loading"
              type="submit"
              large
              @click="() => submit()"
            ) Сохранить
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvManageableComboForm from './DvManageableComboForm.vue';

export default {
  components: {
    DvBtn,
    DvManageableComboForm,
  },
  props: {
    methodCreate: {
      type: Function,
      required: true,
    },
    methodUpdate: {
      type: Function,
      required: true,
    },
    entityNameUpsert: {
      type: String,
      required: true,
    },
    formSchema: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialogId: undefined,
    };
  },
  methods: {
    openForm(item = {}) {
      const {
        entityNameUpsert,
        methodCreate,
        methodUpdate,
      } = this;

      const isEdit = !!item?.id;

      this.dialogId = this.$dialogs.portal({
        attrs: {
          maxWidth: 570,
          title: `${isEdit ? 'Редактирование' : 'Добавление'} ${entityNameUpsert.toLowerCase()}`,
          method: isEdit ? methodUpdate : methodCreate,
          class: 'ui-design',
          item,
        },
      });
    },
    onSuccessForm({ data, close }) {
      const { isEdit, item } = data;
      this.$toast.success(`${isEdit ? 'Изменения сохранены' : 'Тег добавлен'}`);
      this.$emit('form:success', item);
      close();
    },
  },
};
</script>
